import _ from 'lodash'
import { call, select, put } from 'redux-saga/effects'

import biMessages from 'core/data-model/constants/bi-messages'
import { partnerApiRequest } from 'core/service-wrapper/partner-api/handler-request/service-request'
import { getIdentityUser } from 'identity/selectors'
import { updateKYCQuestion } from 'quick-quote/actions'
import { getPartnerKYCQuestion } from 'quick-quote/selectors/partner-selector'

/**
 * createESubmissionApplication
 */
export function createESubmissionApplication() {
  function* prepareData(app) {
    const category = _.get(app, 'quickQuote.selectedDisplayProduct.category')
    if (category === biMessages.CATEGORY_INVESTMENT) {
      const user = yield select(getIdentityUser)
      let kycQuestionnaire = yield select(getPartnerKYCQuestion)

      if (_.isEmpty(kycQuestionnaire)) {
        kycQuestionnaire = yield call(partnerApiRequest.getKYCQuestionnaire, user)
        yield put(updateKYCQuestion(kycQuestionnaire))
      }
    }
  }

  return {
    prepareData: prepareData,
    onCreateApp: prepareData,
    onUpdateApp: prepareData,
  }
}
